"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _vuex = require("vuex");
var _merUseCategory = _interopRequireDefault(require("@/components/merUseCategory"));
var _permission = require("@/utils/permission");
var _public = require("@/libs/public");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
//import detailsFrom from './studioDetail';
// import importGoods from '@/components/importGoods/index'
// 权限判断函数
var _default = exports.default = {
  name: 'StudioList',
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['merchantClassify', 'merchantType'])),
  components: {
    merchantName: _merUseCategory.default
  },
  data: function data() {
    return {
      recommendedLevelStatus: [{
        label: '全部',
        value: ''
      }, {
        label: '5星',
        value: '5'
      }, {
        label: '4星',
        value: '4'
      }, {
        label: '3星',
        value: '3'
      }, {
        label: '2星',
        value: '2'
      }, {
        label: '1星',
        value: '1'
      }],
      merIds: [],
      //商户id
      loadingBtn: false,
      loading: false,
      Loading: false,
      dialogVisible: false,
      importVisible: false,
      listLoading: true,
      studioShowStatusList: [{
        label: '显示',
        value: 1
      }, {
        label: '关闭',
        value: 0
      }],
      studioStatusList: [{
        label: '直播中',
        value: '101'
      }, {
        label: '已结束',
        value: '103'
      }, {
        label: '未开始',
        value: '102'
      }, {
        label: '禁播',
        value: '104'
      }, {
        label: '暂停',
        value: '105'
      }, {
        label: '异常',
        value: '106'
      }, {
        label: '已过期',
        value: '107'
      }],
      tableData: {
        data: [],
        total: 0
      },
      tableForm: {
        page: 1,
        limit: 20,
        reviewStatus: null,
        liveStatus: null,
        keywords: '',
        storeShow: '',
        merType: '',
        star: '',
        merName: ''
      },
      reviewStatus: '',
      keywords: '',
      roomId: '',
      liveRoomStatus: '',
      roomInfo: {},
      isReview: false,
      //是否是审核，true是
      goodsList: [],
      //商品列表
      ruleForm: {
        reviewReason: '',
        reviewStatus: 2,
        id: ''
      },
      loadingBtnSuccess: false //审核成功通过
    };
  },
  mounted: function mounted() {
    if (!this.merchantClassify.length) this.$store.dispatch('merchant/getMerchantClassify');
    if ((0, _permission.checkPermi)(['platform:mp:live:room:list'])) this.getList('');
  },
  methods: {
    checkPermi: _permission.checkPermi,
    close: function close() {
      this.dialogVisible = false;
    },
    //审核拒绝
    cancelForm: function cancelForm() {
      var _this = this;
      this.$modalPrompt('textarea', '拒绝原因').then(function (V) {
        _this.ruleForm.reviewReason = V;
        _this.submit();
      });
    },
    // 审核提交
    onSubmit: function onSubmit(type) {
      var _this2 = this;
      this.ruleForm.reviewStatus = type;
      if (type === 3) {
        this.$modalSure('审核通过该直播间吗？').then(function () {
          _this2.submit();
        });
      } else {
        this.cancelForm();
      }
    },
    submit: function submit() {
      var _this3 = this;
      if (this.ruleForm.reviewStatus === 3) {
        this.loadingBtnSuccess = true;
      } else {
        this.loadingBtn = true;
      }
      this.ruleForm.id = this.roomId;
      (0, _marketing.liveRoomReviewApi)(this.ruleForm).then(function (res) {
        _this3.$message.success('操作成功');
        _this3.dialogVisible = false;
        if (_this3.ruleForm.reviewStatus === 3) {
          _this3.loadingBtnSuccess = false;
        } else {
          _this3.loadingBtn = false;
        }
        _this3.getList();
      }).catch(function (res) {
        if (_this3.ruleForm.reviewStatus === 3) {
          _this3.loadingBtnSuccess = false;
        } else {
          _this3.loadingBtn = false;
        }
      });
    },
    //直播间商品列表
    roomGoodslist: function roomGoodslist() {
      var _this4 = this;
      (0, _marketing.liveRoomGoodsListApi)(this.roomId).then(function (res) {
        _this4.goodsList = res;
      });
    },
    getMerId: function getMerId(id) {
      this.merIds = id;
      this.tableForm.merName = id.toString();
      this.getList();
    },
    // 详情
    onStudioDetails: function onStudioDetails(row, type) {
      this.isReview = type;
      this.roomInfo = row;
      this.roomId = row.id;
      this.dialogVisible = true;
      if (row.reviewStatus === 3 && (0, _permission.checkPermi)(['platform:mp:live:room:goodslist'])) this.roomGoodslist();
    },
    // 删除
    handleDelete: function handleDelete(item, idx) {
      var _this5 = this;
      this.$modalSure('该直播间正在进行直播，删除后不可恢复，您确认删除吗？').then(function () {
        (0, _marketing.liveRoomDeleteApi)(item.id).then(function () {
          _this5.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this5.tableData.data.length, _this5.tableFrom);
          _this5.getList('');
        });
      });
    },
    // 推送消息
    onPushMessage: function onPushMessage(id) {
      var _this6 = this;
      this.$confirm('给长期订阅用户推送消息？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _marketing.studioPushMessageApi)(id).then(function (_ref) {
          var message = _ref.message;
          _this6.$message.success(message);
        }).catch(function (_ref2) {
          var message = _ref2.message;
          _this6.$message.error(message);
        });
      }).catch(function (action) {
        _this6.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 列表
    getList: function getList(num) {
      var _this7 = this;
      this.listLoading = true;
      this.tableData.page = num ? num : this.tableData.page;
      this.tableForm.keywords = encodeURIComponent(this.keywords);
      this.tableForm.reviewStatus = this.reviewStatus ? Number(this.reviewStatus) : null;
      this.tableForm.liveStatus = this.tableForm.liveStatus ? this.tableForm.liveStatus : null;
      (0, _marketing.liveRoomListApi)(this.tableForm).then(function (res) {
        _this7.tableData.data = res.list;
        _this7.tableData.total = res.total;
        _this7.listLoading = false;
      }).catch(function (res) {
        _this7.listLoading = false;
      });
    },
    reset: function reset() {
      this.tableForm = {
        page: 1,
        limit: 20,
        reviewStatus: null,
        liveStatus: null,
        keywords: '',
        storeShow: '',
        merType: '',
        star: ''
      };
      this.merIds = [];
      this.keywords = '';
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.tableForm.page = page;
      this.getList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableForm.limit = val;
      this.getList('');
    },
    //开启回放
    onchangeCloseReplay: function onchangeCloseReplay(row) {
      var _this8 = this;
      liveRoomUpdatereplayApi(row.id, row.closeReplay).then(function () {
        _this8.$message.success('操作成功');
        _this8.getList('');
      });
    },
    // 开启收录
    onchangeIsFeeds: function onchangeIsFeeds(row) {
      var _this9 = this;
      (0, _marketing.liveRoomIsFeedsPublicApi)(row.id, row.isFeedsPublic).then(function () {
        _this9.$message.success('操作成功');
        _this9.getList('');
      });
    },
    //是否显示在商城
    onchangeStoreShow: function onchangeStoreShow(row) {
      var _this0 = this;
      (0, _marketing.liveRoomShowApi)(row.id, row.storeShow).then(function () {
        _this0.$message.success('操作成功');
        _this0.getList('');
      });
    },
    // 禁言
    onchangeIsCommen: function onchangeIsCommen(row) {
      var _this1 = this;
      (0, _marketing.liveRoomUpdatecommentApi)(row.id, row.closeComment).then(function () {
        _this1.$message.success('操作成功');
        _this1.getList('');
      });
    }
  }
};